export default __webpack_public_path__ + "static/media/cross.452c2f65.svg";